"use client"
export { TreatmentEvidenceExplorer as ThermageEvidenceExplorer } from "@/shared/ui/evidence/explorer"
